module.exports = __webpack_public_path__ + "static/device-96abc14a564f526f1422aa0fea9a9810.png";